// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"265":"transactions-detail","380":"gateways-home","759":"settings-home","921":"transactions-home"}[chunkId] || chunkId) + ".js";
};